import React, { lazy, Suspense } from "react";

const LazyAddEstimates = lazy(() => import("./AddEstimates"));

const AddEstimates = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyAddEstimates {...props} />
  </Suspense>
);

export default AddEstimates;
